var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodata"},[_c('Icon',{staticClass:"img",attrs:{"type":"ios-hand","size":"20"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('search_nodata'))+" "),(_vm.$base.getLang() != 'zh-TW')?_c('span',[_vm._v("["),_c('Time',{attrs:{"time":_vm.last_time}}),_vm._v("]")],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b52988f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myNodata.vue
// module id = null
// module chunks = 